import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logoBranco from "../resources/img/logobranco.png";
import CryptoJS from "crypto-js";

function Login() {
  const [evento, setEvento] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Autenticar?codigoLogin=${evento}&senha=${password}`,
        {
          headers: { auth: process.env.REACT_APP_API_TOKEN },
        }
      )
      .then((res) => {
        if (res.data.RETORNO === "200") {
          let codEvento = res.data.CODIGO.toString();
          let eventoEncriptado = CryptoJS.AES.encrypt(
            codEvento,
            process.env.REACT_APP_CYPHER_KEY
          );
          localStorage.setItem("eventoId", eventoEncriptado);
          localStorage.setItem("codEvento", evento);
          localStorage.setItem("nomeEvento", res.data.DESCRICAO);
          const expireDate = new Date();
          expireDate.setHours(expireDate.getHours() + 6);
          localStorage.setItem("expireDate", expireDate.toISOString());

          navigate("/");
        } else {
          setError("Código ou senha inválidos.");
        }
      });
  };

  return (
    <div
      style={{
        backgroundImage:
          "linear-gradient(315deg, rgba(255, 143, 0, 1) 0%, rgba(245, 115, 40, 1) 100%)",
      }}
      className="font-Roboto flex flex-col box-border gap-4 justify-between p-12 items-center min-h-screen w-full overflow-hidden"
    >
      <div className="flex flex-col gap-4 justify-center items-center w-full">
        <img width={273} src={logoBranco} alt="some example image" />
        <h2 className="text-2xl font-bold mb-4 text-center">
          Acesso ao seu evento
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-md w-80 lg:w-1/3">
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <div>
              <label className="block text-center text-sm font-medium">
                Código do Evento
              </label>
              <input
                type="text"
                value={evento}
                onChange={(e) => setEvento(e.target.value)}
                required
                className="input-login w-full box-border p-2.5 py-2.5 rounded placeholder:text-gray-400"
                placeholder="Código do Evento"
              />
            </div>
            <div className="">
              <label className="block text-center text-sm font-medium">
                Senha
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="input-login w-full box-border p-2.5 py-2.5 rounded placeholder:text-gray-400"
                placeholder="Senha"
              />
            </div>
            <div>
              <button
                type="submit"
                className="btn-login w-full py-3 border-none rounded transition cursor-pointer"
              >
                Acessar
              </button>
            </div>

            {error}
          </form>
        </div>
      </div>

      <div>
        <p className="font-light">Santa Ficha © {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}

export default Login;
